import { css } from '@emotion/css';
import { CommentBox, Headline2 } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const title = css`
  font-size: 1rem;
  font-weight: normal;
`;
const commentStyle = css`
  padding-top: 12px;
  padding-bottom: 16px;
`;
interface FeedbackCommentBoxProps {
  setComment: (comment: string) => void;
}

export function FeedbackCommentBox({
  setComment,
}: FeedbackCommentBoxProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Headline2 className={title}>{t('feedbackModal.commentTitle')}</Headline2>
      <div className={commentStyle}>
        <CommentBox
          ariaLabel={t('ariaLabels.commentBox')}
          onWritingComment={setComment}
          placeHolderText={t('feedbackModal.commentPlaceHolder')}
        />
      </div>
    </>
  );
}
